import * as bootstrap from "bootstrap"

window.addEventListener("turbo:load", init_bootstrap);
window.addEventListener("turbo:frame-load", init_bootstrap);

/* Main function to call all initializers */
export function init_bootstrap(event) {
  const html= (event.currentTarget) ? event.currentTarget.document : event
  init_popovers(html);
  init_tooltips(html);
}

/* Set BS Popovers */
function init_popovers(doc= document) {
  const popoverTriggerList = [].slice.call(doc.querySelectorAll('[data-bs-toggle="popover"]'))
  const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {  
    return new bootstrap.Popover(popoverTriggerEl)  
  })

}

/* Set BS Tooltips */
function init_tooltips(doc= document) {

  /* First all links and buttons */
  const tooltipTriggerList1 = doc.querySelectorAll('a[title]:not([data-tooltip="false"][data-bs-toggle="popover"]), button[title]:not([data-tooltip="false"][data-bs-toggle="popover"])')
  const tooltipList1 = [...tooltipTriggerList1].map(
    tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl)
  )

  /* Attach Click event on created popovers to have them disappear when clicked (tapped) on. Necessary for smartphones like IOS */
  tooltipTriggerList1.forEach( (tooltipTriggerEl) => {
    tooltipTriggerEl.addEventListener('shown.bs.tooltip', event => {
      // For tooltips on remote links, hide them after click on smartphones
      let tooltipElm= event.currentTarget;
      tooltipElm.addEventListener('tap', event => {
        bootstrap.Tooltip.getInstance(tooltipElm).hide();
      })
      tooltipElm.addEventListener('click', event => {
        bootstrap.Tooltip.getInstance(tooltipElm).hide();
      })
    })
  })

  /* Tooltips for the rest */
  const tooltipTriggerList2 = doc.querySelectorAll('[title]:not([data-tooltip="false"][data-bs-toggle="popover"])')
  const tooltipList2 = [...tooltipTriggerList2].map(
    tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl)
  )

}
